import React, { useEffect, useRef, useState } from 'react';
import { FiLock, FiMoreVertical, FiSettings, FiUnlock } from 'react-icons/fi';
import { useStorageBox } from '../StorageBoxContext';
import { useStorageBoxSidebarDrawer } from '../StorageBoxSidebarDrawerContext';
import { STORAGE_BOX_LOCK_LABEL } from '../constants';

export default function StorageBoxLockFolderNav() {
  const {
    browseMode,
    lockVaultAccessActive,
    openLockFolder,
    lockFolderNow,
    openLockPinSettings,
    lockConfigured,
    vaultScope,
  } = useStorageBox();

  const [menuOpen, setMenuOpen] = useState(false);
  const closeDrawer = useStorageBoxSidebarDrawer();
  const rootRef = useRef(null);
  const unlocked = lockVaultAccessActive;
  const inLockView = vaultScope === 'lock' || browseMode === 'lock' || browseMode === 'shared';
  const NavIcon = unlocked ? FiUnlock : FiLock;
  const navTitle = unlocked ? `${STORAGE_BOX_LOCK_LABEL} (unlocked)` : `Open ${STORAGE_BOX_LOCK_LABEL}`;

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onDoc = (e) => {
      if (rootRef.current?.contains(e.target)) return;
      setMenuOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [menuOpen]);

  const openMenu = () => setMenuOpen((v) => !v);

  const handlePrimaryClick = () => {
    setMenuOpen(false);
    openLockFolder();
    // Let the PIN modal claim focus before the drawer close moves it to the menu button.
    window.setTimeout(() => closeDrawer(), 0);
  };

  return (
    <div
      className={`sb-lock-nav ${inLockView ? 'sb-lock-nav--active' : ''} ${menuOpen ? 'sb-lock-nav--open' : ''}`}
      ref={rootRef}
    >
      <button
        type="button"
        className="sb-drive-nav-item sb-lock-nav__main"
        onClick={handlePrimaryClick}
        title={navTitle}
        aria-label={navTitle}
      >
        <NavIcon aria-hidden />
        <span className="sb-drive-nav-item__label">{STORAGE_BOX_LOCK_LABEL}</span>
      </button>
      <button
        type="button"
        className="sb-lock-nav__chevron"
        aria-label="Lock folder options"
        aria-expanded={menuOpen}
        aria-haspopup="menu"
        onClick={openMenu}
      >
        <FiMoreVertical aria-hidden />
      </button>
      {menuOpen ? (
        <div className="sb-lock-nav__menu" role="menu">
          {unlocked ? (
            <button
              type="button"
              role="menuitem"
              className="sb-lock-nav__menu-item"
              onClick={() => {
                setMenuOpen(false);
                lockFolderNow();
                closeDrawer();
              }}
            >
              <FiLock aria-hidden />
              Lock
            </button>
          ) : (
            <button
              type="button"
              role="menuitem"
              className="sb-lock-nav__menu-item"
              onClick={() => {
                setMenuOpen(false);
                openLockFolder();
                window.setTimeout(() => closeDrawer(), 0);
              }}
            >
              <FiUnlock aria-hidden />
              Unlock
            </button>
          )}
          <button
            type="button"
            role="menuitem"
            className="sb-lock-nav__menu-item"
            disabled={!lockConfigured}
            onClick={() => {
              setMenuOpen(false);
              openLockPinSettings();
              window.setTimeout(() => closeDrawer(), 0);
            }}
          >
            <FiSettings aria-hidden />
            Settings
          </button>
        </div>
      ) : null}
    </div>
  );
}
